import React from 'react';
import styles from './styles.module.scss';

type Props = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
  'data-testid'?: string;
};

export default function EventTypePill({ label, isActive, onClick, disabled = false, 'data-testid': dataTestId }: Props) {
  return (
    <button
      type="button"
      className={`${styles.pill} ${isActive ? styles.pill_active : ''}`}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {label}
    </button>
  );
}
